import type { useGT } from 'gt-react';
import type { SettableLineApprovalState } from '@erp/rpc';
import type { Table } from '@/lib/tanstack-table';
import type {
  AssignmentLine,
  CartAssignment,
} from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';

export interface CartLineTableMeta {
  onSetApproval: (
    line: AssignmentLine,
    state: SettableLineApprovalState,
  ) => void;
  /** Approved lines: what Release puts on the order. */
  selectedIds: Set<string>;
  onSetStatus: (suggestionId: string, status: 'pending' | 'rejected') => void;
  /** Trash or restore several lines in one call (a need row, a highlight). */
  onSetStatuses?: (
    suggestionIds: readonly string[],
    status: 'pending' | 'rejected',
  ) => void;
  pendingStatusIds: Set<string>;
  cartsByShipTo?: Map<string, CartAssignment>;
  supplierId?: string;
  /** The cart vendor's name, for the From column of a line it buys. */
  vendorName?: string;
  shipToWarehouseId?: string;
  /** `${supplierId}:${shipTo}` — shift-highlight session for bulk modal edits. */
  highlightCartKey?: string;
  sourceWarehouseId?: string;
  editTargets?: (originId: string) => readonly string[];
  gt: ReturnType<typeof useGT>;
}

export function getCartLineTableMeta(
  table: Table<AssignmentLine>,
): CartLineTableMeta {
  const meta = table.options.meta as CartLineTableMeta | undefined;
  if (!meta) {
    throw new Error('cartLineColumns requires CartLineTableMeta on the table');
  }
  return meta;
}
